import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { Checkbox } from '@vio/atlas/src/components/designSystem/Checkbox';
import { filterMessages } from 'components/Filters/filterMessages';
import { FilterUrlParams } from 'modules/search/types';
import { toggle } from 'opticks';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w5imnwi",
  propsAsIs: false
});
interface Props {
  filters: FilterUrlParams;
  handleSingleFilterChange: (value: FilterUrlParams) => void;
}
const BookingOptionsFilterComponent: React.FC<Props> = ({
  filters,
  handleSingleFilterChange
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    isMobile
  } = useDeviceLayout();
  const showPayLaterFilter = toggle('feature-booking-options-pay-later', false, true);
  const isFreeCancellationFilterActive = filters.freeCancellation === '1';
  const isPayLaterFilterActive = filters.payLater === '1';
  return <Wrapper>
      <Checkbox key="freeCancellation" name="freeCancellation" value="freeCancellation" checked={isFreeCancellationFilterActive} onChange={() => handleSingleFilterChange({
      freeCancellation: isFreeCancellationFilterActive ? undefined : '1'
    })} label={formatMessage(filterMessages.freeCancellationTitle)} labelSize={isMobile ? 'bodyM' : 'bodyS'} />
      {showPayLaterFilter && <Checkbox key="payLater" name="payLater" value="payLater" checked={isPayLaterFilterActive} onChange={() => handleSingleFilterChange({
      payLater: isPayLaterFilterActive ? undefined : '1'
    })} label={formatMessage(filterMessages.payLater)} labelSize={isMobile ? 'bodyM' : 'bodyS'} />}
    </Wrapper>;
};
export const BookingOptionsFilter = memo(BookingOptionsFilterComponent);

require("./BookingOptionsFilter.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BookingOptionsFilter.tsx");